import {createContext, useContext} from 'react';
import {AuthContextType} from './types';

// Create Context
export const AuthContext = createContext<AuthContextType>({} as AuthContextType);

// Encapsulated context hook
export const useAuth = () => useContext(AuthContext);
